import { Component } from '@angular/core';
import { AlertComponent } from './alert/alert.component';
import { RouterOutlet } from '@angular/router';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.css'],
    imports: [AlertComponent, RouterOutlet]
})
export class AppComponent {
  
}
